/*
  Total Calls
  Inbound Calls
  Outbound Calls

  Missed Call
  Auto Failed
  Auto Drop
  Agent Answered

agentState list
Customer List
agent List
*/
import { livemonitorAction, globalAction, messageAction } from '../../store/action';
import { v4 as uuidv4 } from 'uuid';
import { buildMessage } from '../../store/helper/call.helper';
import moment from 'moment';
let instance = null;
class LiveMonitor {
  constructor(options) {
    options = options || {};
    if (instance) {
      if (options.emitSocketMessage) {
        instance.emitSocketMessage();
      }
      return instance;
    }
    this.calls = {
      total: 0,
      inbound: 0,
      outound: 0,
      missed: 0,
      drop: 0,
      failed: 0,
      agent: 0,
    }
    this.stateList = {}
    this.transferList = []
    this.transferStateList = {}
    this.agentList = {}
    this.filterList = {}
    this.inboundList = {}
    this.liveData = {}
    this.timeLive = 0;
    this.liveChatData = {}
    this.liveChatStatsData = {}
    this.liveTranscription = []
    this.timeDiff = 0;
    this.timeDiffChat = 0;
    this.timer = 0;
    this.timeApi = 0;
    this.timeApiChatState = 0;
    this.dispatch = null;
    this.emitSocketMessage = options.emitSocketMessage || "";
    this.updateLiveData = this.updateLiveData.bind(this);
    this.startTimer = this.startTimer.bind(this);
    this.stopTimer = this.stopTimer.bind(this);
    this.updateDiff = this.updateDiff.bind(this);
    this.updateDispatch = this.updateDispatch.bind(this);
    this.calculate = this.calculate.bind(this);
    this.process = this.process.bind(this);
    this.getTime = this.getTime.bind(this);
    this.getTimeChat = this.getTimeChat.bind(this);
    this.getCallInfo = this.getCallInfo.bind(this);
    this.getCallInfoLive = this.getCallInfoLive.bind(this);
    this.inboundHandle = this.inboundHandle.bind(this);
    this.getInfo = this.getInfo.bind(this);
    this.updateTransferList = this.updateTransferList.bind(this);
    this.updateOldList = this.updateOldList.bind(this);
    this.calculateCount = this.calculateCount.bind(this);
    this.calculateChatState = this.calculateChatState.bind(this);
    this.calculateLive = this.calculateLive.bind(this);
    this.defineFilter = this.defineFilter.bind(this);
    this.updateLiveChatData = this.updateLiveChatData.bind(this);
    this.updateNewLiveChatData = this.updateNewLiveChatData.bind(this);
    this.updateLiveChatStatsData = this.updateLiveChatStatsData.bind(this);
    instance = this;
    // this.startTimer();
  }
  getTime(currentStamp, timeStamp) {
    let timeDiff = currentStamp + this.timeDiff - timeStamp;
    if (!isNaN(timeDiff) && timeDiff > 0) {
      return { time: moment.utc(timeDiff * 1000).format("HH:mm:ss"), diff: timeDiff };
    } else {
      return { time: "00:00:00", diff: 0 };
    }
  }
  checkTime(currentStamp) {
    try {
      let time = currentStamp.toString();
      if (time.length != 10) {
        time = time.substring(0, 10);
        return time;
      } else {
        return currentStamp;
      }
    } catch (error) {
      return currentStamp;
    }
  }
  getTimeChat(currentStamp, timeStamp) {
    currentStamp = this.checkTime(currentStamp);
    timeStamp = this.checkTime(timeStamp);
    let timeDiff = currentStamp + this.timeDiffChat - timeStamp;
    if (!isNaN(timeDiff) && timeDiff > 0) {
      return { time: moment.utc(timeDiff * 1000).format("HH:mm:ss"), diff: timeDiff };
    } else {
      return { time: "00:00:00", diff: 0 };
    }
  }
  updateDispatch(dispatch) {
    this.dispatch = dispatch;
  }
  updateTransferList(dispatch, list) {
    let _this = this;
    this.transferStateList = {};
    this.transferList = list;
    this.updateDispatch(dispatch);
    setTimeout(() => {
      _this.updateOldList(dispatch);
    }, 1000);
  }
  updateOldList(dispatch) {
    let _this = this;
    if (this.transferList) {
      this.transferStateList = {};
      this.transferList.map((agentId) => {
        if (_this.agentList[agentId]) {
          let agent = _this.agentList[agentId];
          let agentState = agent.State || "-";
          if (agentState == "online") {
            let userInfo = agent.userInfo || {};
            _this.transferStateList[agent.UserId] = {
              id: agent.UserId,
              name: userInfo.name || agent.UserName || "No Name",
              username: agent.UserName || "No Name",
            }
          }
        }
      })
      dispatch(globalAction.dynamicUpdate({ data: { "key": "transferList", value: this.transferStateList } }))
      setTimeout(() => {
        dispatch(globalAction.dynamicUpdate({ data: { "key": "transferId", value: uuidv4() } }));
      }, 1000);
    }
  }
  startTimer() {
    let _this = this;
    this.stopTimer()
    this.timer = setInterval(() => {
      _this.calculate()
    }, 1000)
    this.timeApi = setInterval(() => {
      _this.calculateCount()
    }, 5000);
    this.timeApiChatState = setInterval(() => {
      _this.calculateChatState()
    }, 3000);
    this.timeLive = setInterval(() => {
      _this.calculateLive()
    }, 1000)
  }
  updateLiveData(data) {
    this.liveData = data;
  }
  updateLiveChatData(data) {
    this.liveChatData = data;
    // this.dispatch(livemonitorAction.dynamicUpdate({
    //   "liveChatData": data
    // }))
  }
  updateNewLiveChatData(data) {
    const sessionId = data.sessionId;

    const recalculateTotalActiveSession = (totalStatus) => {
      // Ensure totalStatus is an object
      if (!totalStatus || typeof totalStatus !== 'object') {
        console.warn("totalStatus is undefined or not an object. Defaulting to an empty object.");
        totalStatus = {};
      }

      const activeStatuses = ['assign', 'flow', 'queue'];
      return activeStatuses.reduce((sum, status) => sum + (totalStatus[status] || 0), 0);
    };

    if (!sessionId) {
      console.error("Invalid data: sessionId is missing.");
      return;
    }

    // Ensure totalCustomerList exists and is an array
    if (!Array.isArray(this.liveChatData.totalCustomerList)) {
      this.liveChatData.totalCustomerList = [];
    }

    if (!this.liveChatData.totalStatus || typeof this.liveChatData.totalStatus !== 'object') {
      this.liveChatData.totalStatus = {};
    }

    const customerList = this.liveChatData.totalCustomerList || [];
    const totalStatus = this.liveChatData.totalStatus || {};
    const totalCount = this.liveChatData.totalCount || {};
    // const totalActiveSession = this.liveChatData.totalStatus.totalActiveSession;

    // Check if the session already exists in the customer list
    const sessionIndex = customerList.findIndex((entry) => entry.sessionId === sessionId);
    const oldStatus = sessionIndex !== -1 ? customerList[sessionIndex].status : null;
    const oldMedium = sessionIndex !== -1 ? customerList[sessionIndex].medium : null;
    const newStatus = data.status;
    const newMedium = data.medium;

    // 1. Close Event
    if (data.status === "closed") {
      if (sessionIndex !== -1) {
        // Remove the session from the list and decrease totalActiveSession
        customerList.splice(sessionIndex, 1);
        // Decrease the totalActiveSession count
        // this.liveChatData.totalStatus.totalActiveSession -= 1;
        // Decrease from totalStatus
        if (totalStatus[oldStatus]) {
          totalStatus[oldStatus] -= 1;
        }

        // Decrease from totalCount (medium)
        if (totalCount[oldMedium]) {
          totalCount[oldMedium] -= 1;
        }
      }
    }

    // 2. Insert Event
    else if (sessionIndex === -1 && data.status !== "closed") {
      // Add the new session to the list and increase totalActiveSession
      customerList.push(data);

      // Increase the totalActiveSession count
      // this.liveChatData.totalStatus.totalActiveSession += 1;

      // Increase count for the status in totalStatus
      if (totalStatus[newStatus]) {
        totalStatus[newStatus] += 1;
      } else {
        totalStatus[newStatus] = 1;
      }

      // Increase count for the medium in totalCount
      if (totalCount[newMedium]) {
        totalCount[newMedium] += 1;
      } else {
        totalCount[newMedium] = 1;
      }
    }

    // 3. Update Event
    else if (sessionIndex !== -1 && (oldStatus !== newStatus || oldMedium !== newMedium)) {
      // If status or medium is changing, handle accordingly

      // Remove the old status count
      if (oldStatus !== null && totalStatus[oldStatus]) {
        totalStatus[oldStatus] -= 1;
      }

      // Add the new status count
      if (totalStatus[newStatus]) {
        totalStatus[newStatus] += 1;
      } else {
        totalStatus[newStatus] = 1;
      }

      // Remove the old medium count
      if (oldMedium !== null && totalCount[oldMedium]) {
        totalCount[oldMedium] -= 1;
      }

      // Add the new medium count
      if (totalCount[newMedium]) {
        totalCount[newMedium] += 1;
      } else {
        totalCount[newMedium] = 1;
      }

      // Update the session with new data
      customerList[sessionIndex] = {
        ...customerList[sessionIndex],  // Keep existing data
        ...data,  // Overwrite with new data
      };
    }

    // Update the liveChatData object with the updated customer list, totalStatus, totalCount, and totalActiveSession
    this.liveChatData.totalCustomerList = customerList;
    this.liveChatData.totalStatus = totalStatus;
    this.liveChatData.totalCount = totalCount;
    this.liveChatData.totalStatus.totalActiveSession = recalculateTotalActiveSession(this.liveChatData.totalStatus || {});

    // Dispatch the updated liveChatData
    this.dispatch(
      livemonitorAction.updateLiveChatData({
        liveChatData: this.liveChatData,
      })
    );
  }
  //   updateNewLiveChatData(data) {

  //     const sessionId = data.sessionId;

  //     if (!sessionId) {
  //       console.error("Invalid data: sessionId is missing.");
  //       return;
  //     }

  //     // Ensure totalCustomerList exists and is an array
  //     if (!Array.isArray(this.liveChatData.totalCustomerList)) {
  //       this.liveChatData.totalCustomerList = [];
  //     }

  //     if (typeof totalActiveSession !== 'number') {
  //   console.error('Invalid totalActiveSession value. Resetting to 0.');
  //   this.liveChatData.totalStatus.totalActiveSession = 0;
  // }

  //     const customerList = this.liveChatData.totalCustomerList;
  //     const totalStatus = this.liveChatData.totalStatus;
  //     const totalCount = this.liveChatData.totalCount;
  //     const totalActiveSession = this.liveChatData.totalStatus.totalActiveSession;

  //     // Check if the session already exists in the customer list
  //     const sessionIndex = customerList.findIndex((entry) => entry.sessionId === sessionId);
  //     const oldStatus = sessionIndex !== -1 ? customerList[sessionIndex].status : null;
  //     const oldMedium = sessionIndex !== -1 ? customerList[sessionIndex].medium : null;
  //     const newStatus = data.status;
  //     const newMedium = data.medium;

  //     // 1. Close Event
  //     if (data.status === "closed") {
  //       if (sessionIndex !== -1) {
  //         // Remove the session from the list and decrease totalActiveSession
  //         customerList.splice(sessionIndex, 1);

  //         // Decrease the totalActiveSession count
  //         this.liveChatData.totalStatus.totalActiveSession -= 1;

  //         // Decrease from totalStatus
  //         if (totalStatus[oldStatus]) {
  //           totalStatus[oldStatus] -= 1;
  //         }

  //         // Decrease from totalCount (medium)
  //         if (totalCount[oldMedium]) {
  //           totalCount[oldMedium] -= 1;
  //         }
  //       }
  //     }

  //     // 2. Insert Event
  //     else if (sessionIndex === -1 && data.status !== "closed") {
  //       // Add the new session to the list and increase totalActiveSession
  //       customerList.push(data);

  //       // Increase the totalActiveSession count
  //       this.liveChatData.totalStatus.totalActiveSession += 1;

  //       // Increase count for the status in totalStatus
  //       if (totalStatus[newStatus]) {
  //         totalStatus[newStatus] += 1;
  //       } else {
  //         totalStatus[newStatus] = 1;
  //       }

  //       // Increase count for the medium in totalCount
  //       if (totalCount[newMedium]) {
  //         totalCount[newMedium] += 1;
  //       } else {
  //         totalCount[newMedium] = 1;
  //       }
  //     }

  //     // 3. Update Event
  //     else if (sessionIndex !== -1 && (oldStatus !== newStatus || oldMedium !== newMedium)) {
  //       // If status or medium is changing, handle accordingly

  //       // Remove the old status count
  //       if (oldStatus !== null && totalStatus[oldStatus]) {
  //         totalStatus[oldStatus] -= 1;
  //       }

  //       // Add the new status count
  //       if (totalStatus[newStatus]) {
  //         totalStatus[newStatus] += 1;
  //       } else {
  //         totalStatus[newStatus] = 1;
  //       }

  //       // Remove the old medium count
  //       if (oldMedium !== null && totalCount[oldMedium]) {
  //         totalCount[oldMedium] -= 1;
  //       }

  //       // Add the new medium count
  //       if (totalCount[newMedium]) {
  //         totalCount[newMedium] += 1;
  //       } else {
  //         totalCount[newMedium] = 1;
  //       }

  //       // Update the session with new data
  //       customerList[sessionIndex] = {
  //         ...customerList[sessionIndex],  // Keep existing data
  //         ...data,  // Overwrite with new data
  //       };
  //     }

  //     // Update the liveChatData object with the updated customer list, totalStatus, totalCount, and totalActiveSession
  //     this.liveChatData.totalCustomerList = customerList;
  //     this.liveChatData.totalStatus = totalStatus;
  //     this.liveChatData.totalCount = totalCount;
  //     this.liveChatData.totalStatus.totalActiveSession = totalActiveSession;

  //     // Dispatch the updated liveChatData
  //     this.dispatch(
  //       livemonitorAction.updateLiveChatData({
  //         liveChatData: this.liveChatData,
  //       })
  //     );
  //   }


  updateLiveChatStatsData(data) {
    this.liveChatStatsData = data;
    this.dispatch(livemonitorAction.dynamicUpdate({
      "liveChatStatsData": data
    }))
  }
  updateLiveTransctiption(data) {
    this.liveTranscription = data;
    this.dispatch(livemonitorAction.liveTranscriptionUpdate({
      "liveTranscriptionUpdate": data
    }))
  }
  defineFilter(filter) {
    this.filterList = filter || {}
    this.agentList = {};
  }
  getUpdatedState(stateName) {
    let state = "";
    switch (stateName) {
      case "ACW":
        state = "ACW";
        break;
      case "Preview":
      case "preview":
        state = "Preview";
        break;
      case "offline":
        state = "Offline";
        break;
      case "online":
        state = "Online";
        break;
      case "break":
        state = "Break";
        break;
      case "logout":
        state = "Logout";
        break;
      case "TRANSFER_TALK":
      case "TRANSFER_START":
      case "TRANSFER_CALL":
        state = "Transfer";
        break;
      case "AGENT_CONNECTING":
      case "AGENT_RINING":
      case "AGENT_CONNECTED":
      case "CUSTOMER_CONNECTING":
      case "CUSTOMER_RINING":
        state = "Ringing";
        break;
      case "CUSTOMER_CONNECTED":
      case "CONNECTED":
        state = "Connected";
        break;
      case "AGENT_MUTE":
      case "MUTE":
        state = "Mute";
        break;
      case "AGENT_HOLD":
      case "HOLD":
        state = "Hold";
        break;
      default:
        state = stateName;
        break;
    }
    return state;
  }
  calculateCount(data) {
    data = data || {};
    // let configInfo = {
    //   pattern: 'user:resents',
    //   type: 'contactHandler',
    //   body: {
    //     ...data
    //   },
    //   subtype: 'user:live:monitor',
    //   replayTo: 'notification-to-ui'
    // };
    // configInfo = buildMessage(configInfo);
    // if( this.emitSocketMessage ){
    //   this.emitSocketMessage(`message-processor`, configInfo);
    // }

    let configInfo1 = {
      pattern: 'user:live:monitor',
      type: 'callHandler',
      body: {
        limit: 20,
        page_no: 0,
        ...this.filterList
      },
      subtype: 'user:live:monitor',
      replayTo: 'notification-to-ui'
    };
    configInfo1 = buildMessage(configInfo1);
    if (this.emitSocketMessage) {
      this.emitSocketMessage(`message-processor`, configInfo1);
    }
  }

  calculateChatState(data) {
    data = data || {};
    let configInfo1 = {
      pattern: 'live:monitor:chat:stats',
      type: 'callHandler',
      body: {
        limit: 20,
        page_no: 0,
      },
      subtype: 'live:monitor:chat:stats',
      replayTo: 'notification-to-ui'
    };
    configInfo1 = buildMessage(configInfo1);
    if (this.emitSocketMessage) {
      this.emitSocketMessage(`message-processor`, configInfo1);
    }
  }
  forceStop() {
    this.stopTimer()
    if (this.dispatch) {
      this.dispatch(livemonitorAction.dynamicUpdate({
        "customerList": [],
        "list": [],
        "state": {},
        "inboundState": {}
      }))
      try {
        this.stateList = {}
        this.transferList = []
        this.transferStateList = {}
        this.agentList = {}
        this.filterList = {}
        this.inboundList = {}
        this.liveData = {}
      } catch (error) {
        console.log("forceStop Errror", error);
      }
    }
  }
  stopTimer() {
    clearInterval(this.timer);
    clearInterval(this.timeApi);
    clearInterval(this.timeApiChatState);
    clearInterval(this.timeLive);
  }
  updateDiff(serverStamp) {
    if (serverStamp) {
      this.timeDiff = serverStamp - parseInt(new Date() / 1000)
      this.timeDiffChat = serverStamp - parseInt(new Date() / 1000)
    }
  }
  calculateLive() {
    let liveChatData = this.liveChatData.totalCustomerList || []
    let liveChatList = []
    let currentStamp = parseInt(new Date() / 1000);
    if (liveChatData) {
      for (const liveId in liveChatData) {
        let live = liveChatData[liveId] || {}
        let startTime = live.startTime ? parseInt(live.startTime) : null;
        let timeInfo = {};
        if (startTime) {
          timeInfo = this.getTimeChat(currentStamp, startTime);
        }
        let callInfo = this.getCallInfoLive(live);

        let info = {
          id: live.sessionId,
          medium: live.medium,
          customer: live.customer || "-",
          status: live.status,
          callInfo: callInfo,
          agent: callInfo.agent || "-",
          team: callInfo.team || "-",
          campaign: callInfo.campaign || "-",
          time: startTime,
          humanTime: timeInfo.time || "-",
          diff: timeInfo.diff || "-",
          identifier: live.identifier || "",
        }
        // list.push(info);
        liveChatList.push(info);
      }
    }
    if (this.dispatch) {
      this.dispatch(livemonitorAction.dynamicUpdate({
        "liveChatData": this.liveChatData,
        "liveChatList": liveChatList,
      }))
    }
    // this.dispatch(livemonitorAction.dynamicUpdate({
    //   "liveChatData": data
    // }))
  }
  calculate() {
    let agentList = this.agentList
    let list = []
    let customerList = []
    let state = {}
    let inboundState = {}
    let currentStamp = parseInt(new Date() / 1000);
    if (agentList) {
      for (const agentId in agentList) {
        // get info from data
        let agent = agentList[agentId] || {};
        let name = agent.userInfo && agent.userInfo.name ? agent.userInfo.name : "";
        // get state data
        let agentState = agent.State || "-";
        let startTime = parseInt(agent.StartTime) || "";

        // calculate time
        let timeInfo = {};
        if (startTime) {
          timeInfo = this.getTime(currentStamp, startTime);;
        }
        // mainType
        let mainType = agentState != "ACW" && agent.mainType ? agent.mainType : "-"
        if (mainType == "call" || agentState == "ACW") {
          // update user info
          let callInfo = this.getCallInfo(agent);
          let updateState = this.getUpdatedState(agentState);
          let info = {
            id: agentId,
            name: name || agent.Name || agent.UserName || "No Name",
            username: agent.UserName || "No Name",
            systemState: agentState,
            state: updateState,
            time: startTime,
            humanTime: timeInfo.time || "-",
            diff: timeInfo.diff || "-",
            actions: updateState,
            mainType: mainType,
            info: this.getInfo(agent),
            callInfo: callInfo,
            userId: agent.UserId,
            customer: callInfo.customer || "-",
            team: callInfo.team || "-",
            campaign: callInfo.campaign || "-",
            callType: callInfo.callType || "-",
            isRecorded: callInfo.isRecorded || "-",
          }
          customerList.push(info);
          state[updateState] = state[updateState] ? ++state[updateState] : 1;
        } else {
          let stateInfo = this.getInfo(agent);
          let updateState = this.getUpdatedState(agentState);
          let detail = updateState == "Break" && stateInfo != "" ? `${agentState} ( ${stateInfo} )` : updateState;
          // update user info
          let info = {
            id: agentId,
            name: name || agent.Name || agent.UserName || "No Name",
            username: agent.UserName || "No Name",
            state: detail,
            systemState: agentState,
            actions: detail,
            time: startTime,
            humanTime: timeInfo.time || "-",
            diff: timeInfo.diff || "-",
            mainType: mainType,
            info: this.getInfo(agent),
            callInfo: "",
            userId: agent.UserId,
          }
          if (info.state == "Logout" && startTime < moment().startOf('day').unix()) {

          } else {
            list.push(info);
          }
          state[updateState] = state[updateState] ? ++state[updateState] : 1;
        }
      }
    }
    inboundState["IVR"] = 0;
    inboundState["Queue"] = 0;
    inboundState["IVR Drop"] = this.liveData.missedCall || 0;
    inboundState["Agent Answered"] = this.liveData.agentCallAnsweredCount || 0;
    inboundState["Auto Drop"] = this.liveData.autoDropCall || 0;
    inboundState["Auto Failed"] = this.liveData.failedCalls || 0;
    if (this.inboundList) {
      for (const callId in this.inboundList) {
        let info = this.inboundList[callId];
        // calculate time
        let timeInfo = {};
        if (info.time) {
          timeInfo = this.getTime(currentStamp, info.time);;
        }
        info.humanTime = timeInfo.time || "-"
        info.diff = timeInfo.diff || "-"
        inboundState[info.state] = inboundState[info.state] ? inboundState[info.state] + 1 : 1;
        customerList.push(info);
      }
    }

    if (this.dispatch) {
      this.dispatch(livemonitorAction.dynamicUpdate({
        "liveData": this.liveData,
        "customerList": customerList,
        "list": list,
        "state": state,
        "inboundState": inboundState
      }))
    }
  }
  getCallInfo(agent) {
    let callInfo = {}
    if (agent.mainType && agent.mainType == "call") {
      let info = agent.callInfo || agent.extraData || {}
      if (info.team && info.team.name) {
        callInfo.team = info.team.name;
      }
      if (info.team && info.team) {
        callInfo.teamId = info.team._id || info.team.id || "";
      }

      if (info.campaign && info.campaign.name) {
        callInfo.campaign = info.campaign.name;
      }
      if (info.campaign && info.campaign) {
        callInfo.campaignId = info.campaign._id || info.campaign.id || "";
      }
      if (info.callType) {
        callInfo.callType = info.callType;
      }
      if (info.call1 && info.call1.isAgent) {
        callInfo.sessionId = info.call1.sessionId;
        callInfo.callId = info.call1.Id;
        callInfo.isRecorded = info.call1.isRecorded;
      } else if (info.call2 && info.call2.isAgent) {
        callInfo.sessionId = info.call2.sessionId;
        callInfo.callId = info.call2.Id;
        callInfo.isRecorded = info.call1.isRecorded;
      } else if (info.calls && info.calls.length) {
        info.calls.map((data) => {
          if (data.isAgent) {
            callInfo.sessionId = data.sessionId;
            callInfo.callId = data.Id;
            callInfo.isRecorded = info.call1.isRecorded;
          }
        })
      }

      if (info.call1 && !info.call1.isAgent) {
        callInfo.custId = info.call1.Id;
        callInfo.customer = info.call1.number;
      } else if (info.call2 && !info.call2.isAgent) {
        callInfo.custId = info.call2.Id;
        callInfo.customer = info.call2.number;
      }
    }
    return callInfo;
  }
  getCallInfoLive(live) {
    let callInfo = {};
    let info = live || {}; // Default to an empty object if undefined

    if (info.agent) {
      callInfo.agent = info.agent.name || "-";
      callInfo.agentId = info.agent._id || info.agent.id || "-";
    } else {
      callInfo.agent = "-";
      callInfo.agentId = "-";
    }

    if (info.team) {
      callInfo.team = info.team.name || "-";
      callInfo.teamId = info.team._id || info.team.id || "-";
    } else {
      callInfo.team = "-";
      callInfo.teamId = "-";
    }

    if (info.campaign) {
      callInfo.campaign = info.campaign.name || "-";
      callInfo.campaignId = info.campaign._id || info.campaign.id || "-";
    } else {
      callInfo.campaign = "-";
      callInfo.campaignId = "-";
    }

    return callInfo; // Add return to ensure callInfo is returned to the caller
  }

  getInboundCallInfo(info) {
    let callInfo = {}
    if (info.call1) {
      callInfo.sessionId = info.call1.sessionId;
      callInfo.callId = info.call1.Id;
      callInfo.isRecorded = info.call1.isRecorded || false;
      callInfo.custId = info.call1.custId;
      callInfo.customer = info.call1.number;
      callInfo.startTimeStamp = info.call1.startTimeStamp;
      if (info.team && info.team.name) {
        callInfo.team = info.team.name;
      }
      if (info.campaign && info.campaign.name) {
        callInfo.campaign = info.campaign.name;
      }
    }
    return callInfo;
  }
  getInfo(agent) {
    let info = "";
    if (agent.State) {
      if (agent.State == "break") {
        info = agent.stateObj && agent.stateObj.name ? agent.stateObj.name : "";
      }
    }
    return info;
  }
  async inboundHandle(dispatch, data) {
    if (data.data) {

      // update dispatch
      this.updateDispatch(dispatch);

      let callInfo = this.getInboundCallInfo(data.data);
      if (data.subType == "QUEUE" || data.subType == "IVR") {
        let startTime = parseInt(callInfo.startTimeStamp / 1000) || "";
        let currentStamp = parseInt(new Date() / 1000);
        // calculate time
        let timeInfo = {};
        if (startTime) {
          timeInfo = this.getTime(currentStamp, startTime);;
        }
        let info = {
          id: callInfo.callId,
          name: "",
          username: "",
          state: data.subType,
          time: startTime,
          mainType: "",
          info: {},
          callInfo: callInfo,
          userId: "",
          customer: callInfo.customer || "-",
          team: callInfo.team || "-",
          campaign: callInfo.campaign || "-",
          callType: "inbound",
          isRecorded: callInfo.isRecorded || "-",
        }
        this.inboundList[callInfo.callId] = info;
      } else {
        if (callInfo.callId && this.inboundList[callInfo.callId]) {
          delete this.inboundList[callInfo.callId]
        }
      }
    }
  }
  async process(dispatch, data) {
    // set agent state

    // update dispatch
    this.updateDispatch(dispatch)

    // update timer
    if (data.currentTime) {
      let serverStamp = parseInt(data.currentTime / 1000) || 0;
      this.updateDiff(serverStamp)
    }

    // update user data to live monitor state
    if (data && data.data && data.data.UserId) {
      let agent = data.data;
      this.agentList[agent.UserId] = agent;
      if (this.transferList && this.transferList.indexOf(agent.UserId) > -1) {
        let agentState = agent.State || "-";
        if (agentState == "online") {
          this.transferStateList[agent.UserId] = {
            id: agent.UserId,
            name: agent.name || agent.Name || agent.UserName || "No Name",
            username: agent.UserName || "No Name",
          }
          dispatch(globalAction.dynamicUpdate({ data: { "key": "transferList", value: this.transferStateList } }));
          dispatch(globalAction.dynamicUpdate({ data: { "key": "transferId", value: uuidv4() } }));
        } else {
          if (this.transferStateList[agent.UserId]) {
            delete this.transferStateList[agent.UserId];
            dispatch(globalAction.dynamicUpdate({ data: { "key": "transferList", value: this.transferStateList } }));
            dispatch(globalAction.dynamicUpdate({ data: { "key": "transferId", value: uuidv4() } }));

          }
        }
      } else {
      }
      // dispatch(livemonitorAction.setLiveAgentList({"key":data.data.UserId,"value":data.data}))
      // dispatch(livemonitorAction.dynamicUpdate({
      //   "key":"timeStamp",
      //   "value": data.currentTime || parseInt(new Date()/1000)
      // }))
      // dispatch(livemonitorAction.dynamicUpdate({
      //   "key":"timeDiff",
      //   "value": timeDiff
      // }))
      // dispatch(livemonitorAction.dynamicUpdate({
      //   "key":"uuid",
      //   "value": uuidv4()
      // }))
    } else {
      console.log("liveMonitorProcess error ---", data);
    }
  }
}
export default LiveMonitor;


// WEBPACK FOOTER //
// src/dialpad/service/livemonitor.service.js